export const deserialize = (data: any) => {
	if (typeof data !== "string") {
		return data;
	}

	try {
		return data && JSON.parse(data);
	} catch {
		return undefined;
	}
};
